<div class="checklist-options-container">
	@for (option of checklistOptions(); track option; let index = $index) {
		<div class="checklist-option-input m-b-sm">
			<span class="option-index">{{ index + 1 }}.</span>
			<div class="input-control">
				<input
					type="text"
					[placeholder]="'enter_task' | translate"
					(keydown.enter)="addNewOption($event)"
					[ngModel]="option.question"
					(ngModelChange)="optionChanged($event, index)"
				/>
				@if (optionsCount() > 1) {
					<mat-icon
						svgIcon="delete"
						class="critical-icon cursor-pointer"
						(click)="deleteOption(index)"
					/>
				}
			</div>
		</div>
	}
	<div class="action-row">
		<div class="add-new-checklist-option" (click)="addNewOption($event)">
			<button mat-mini-fab class="surface-fab">
				<mat-icon svgIcon="add" />
			</button>
			<span>{{ 'add_checklist_item' | translate }}</span>
		</div>

		@if (showActionButtons) {
			<div class="action-buttons-group">
				<button mat-stroked-button (click)="cancelAction()">
					{{ 'cancel' | translate }}
				</button>
				<button
					mat-flat-button
					color="primary"
					class="checklist-action-btn"
					(click)="saveAction()"
					[disabled]="!onlyFilledOptions().length"
				>
					<span class="align-text-wrapper">
						<span>{{ 'save' | translate }}</span>
					</span>
				</button>
			</div>
		}
	</div>
</div>
